<template>
  <div style="margin-top: 20px; padding-bottom: 20px">
    <!-- <h3 class="noPddingTitle font_bold ">经济效益</h3> -->
    <h3 class="title title_mark" style="positon: relative; left: -20px;margin-bottom:0">经济效益</h3>
    <a-alert
      v-if="messageList.length"
      style="margin: -20px 0 10px;"
      type="error"
      :message="msg"
      banner
      closable
    />
    <h3
      class="noPddingTitle font_bold"
      style="font-size: 14px; margin: 0px 0 2px"
    >
      经济效益预估区间：{{ description }}kg
    </h3>
    <p style="font-size: 13px; margin-bottom: 14px">
      若经济效益预估体重区间小于20-140kg，可能造成预估的饲料成本和生产成本偏低、经济效益偏高的异常情况
    </p>

    <a-table
      :loading="loading"
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text, r">
        <span :key="el">
          <template v-if="el.indexOf('Val4') >= 0 || el.indexOf('Val3') >= 0">
            <template v-if="r[el] && r[el] !== '-'">
              <!-- {{ r[el] && r[el] !== '-' ? Number(r[el]).toFixed(2) + '%' : "-" }} -->
              <span v-if="Number(r[el]) > 0" style="color: red;">+{{Number(r[el]).toFixed(2)}}<span  v-if="el.indexOf('Val4') >= 0">%</span></span>
              <span v-if="Number(r[el]) < 0" style="color: #5eab73;">{{Number(r[el]).toFixed(2)}}<span  v-if="el.indexOf('Val4') >= 0">%</span></span>
              <span v-if="Number(r[el]) === 0">-</span>
              
            </template>
            <span v-else>-</span>
          </template>
          <template v-else>{{ r[el] && r[el] !== '-' ? Number(r[el]).toFixed(2) : "-" }}</template>
        </span>
      </template>
    </a-table>
  
    <!-- 渲染经济效益图表 -->
    <!-- <div class="cardBox">
      <ChartsOne
        class="chartStyle"
        v-for="(item, index) in chartResources"
        :key="index"
        :dataset="item.dataset"
        :titleText="item.titleText"
      ></ChartsOne>
    </div> -->
  </div>
</template>
<script>
import {
  economicColums,
  economicList,
} from "../../../../EstimateConfig/estimateConfig";
import { chartsOne } from "../../../../EstimateConfig/copyConfig";
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from "vuex";
// import ChartsOne from "../../../../../Common/components/ChartsOne.vue";
export default {
  props: ["isAdd", "resId", "tabKey", "energySystemNameA"],
  // components: { ChartsOne },
  data() {
    return {
      list: [],
      estimateId: getRequest("id"),
      loading: false,
      sectionList: [],
      economicList,
      fixedArr: [], //保存观测值数据，省略后两位
      flag: false,
      messageList: [],
      chartResources: [],
      chartsOne,
      description: "", //体重区间
    };
  },
  mounted() {
    this.init();
    if (this.weightData) {
      let { min, max } = this.weightData;
      this.description = `${min}-${max}`;
    }
  },
  computed: {
    ...mapState("estimate", [ "weightData"]),
    ...mapState("procedure", ["procedureDetail"]),
    msg(){
      let str = ''
      this.messageList.forEach((el) => {
        str += `<p>${el.message.replace(/\[/g,"<span style='color: rgb(0, 162, 255)'>[").replace(/\]/g,"]</span>")}</p>`
        if(el.subMessages && el.subMessages.length > 0){
          el.subMessages.forEach(item => {
            str += `<p>${item.message.replace(/\[/g,"<span style='color: rgb(0, 162, 255)'>[").replace(/\]/g,"]</span>")}</p>`
          })
        }
      })
      return <div domPropsInnerHTML={str}></div>
    },
    columns() {
      let newColumns = [...economicColums];
      if (this.sectionList.length > 1) {
        this.sectionList.forEach((el, index) => {
          newColumns.push({
            title: el.name,
            children: [
              {
                title: "当前配方",
                dataIndex: `f${index}Val1`,
                scopedSlots: { customRender: `f${index}Val1` },
                width: 100,
              },
              {
                title: "推荐配方",
                dataIndex: `f${index}Val2`,
                scopedSlots: { customRender: `f${index}Val2` },
                width: 100,
              },
              {
                title: "差异",
                dataIndex: `f${index}Val3`,
                scopedSlots: { customRender: `f${index}Val3` },
                width: 100,
              },
              {
                title: "差异比例（%）",
                dataIndex: `f${index}Val4`,
                scopedSlots: { customRender: `f${index}Val4` },
                width: 100,
              },
            ],
          });
        });
      } else {
        newColumns.push({
          title: "当前配方",
          dataIndex: "f0Val1",
          scopedSlots: { customRender: `f0Val1` },
        });
        newColumns.push({
          title: "推荐配方",
          dataIndex: "f0Val2",
          scopedSlots: { customRender: `f0Val2` },
        });
        newColumns.push({
          title: "差异",
          dataIndex: `f0Val3`,
          scopedSlots: { customRender: `f0Val3` },
        });
        newColumns.push({
          title: "差异比例（%）",
          dataIndex: `f0Val4`,
          scopedSlots: { customRender: `f0Val4` },
        });
      }
      return newColumns;
    },
  },
  watch: {
    resId(val) {
      if (val) {
        this.flag = false;
        setTimeout(() => {
          this.getDetails(val);
        }, 0);
      }
    },
    tabKey() {
      if (this.resId && !this.flag) {
        this.init(this.resId);
      }
    },
    weightData: {
      handler(val) {
        if (val) {
          let { min, max } = val;
          this.description = `${min}-${max}`;
        }
      },
      deep: true,
    },
  },
  methods: {
    getDetails(predictionId) {
      if (!predictionId) {
        return;
      }
      this.loading = true;
      this.flag = true;
      this.$get(
        "/sat-maximization/opeconomicbenefit/opEconomicBenefitByPredictionId",
        { predictionId }
      )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            this.loading = false;
            this.sectionList = []; //清空

            let { opEconomicBenefitVOList } = data;
            this.messageList = data.messageList || []

            //动态生成头部区间
            if (opEconomicBenefitVOList && opEconomicBenefitVOList.length > 0) {
              opEconomicBenefitVOList.forEach((el, index) => {
                this.sectionList.push({
                  name: `${el.feedingprogramStartWeight}-${el.feedingprogramEndWeight}kg`,
                  field: `${el.feedingprogramStartWeight}-${el.feedingprogramEndWeight}`,
                });
                this.fixedArr.push(`f${index}Val1`);
                this.fixedArr.push(`f${index}Val2`);
                this.fixedArr.push(`f${index}Val3`);
                this.fixedArr.push(`f${index}Val4`);
              });
            } else {
              this.fixedArr.push(`f0Val1`);
              this.fixedArr.push(`f0Val2`);
              this.fixedArr.push(`f0Val3`);
              this.fixedArr.push(`f0Val4`);
            }

            //动态生成数据
            let list = [];
            this.economicList.forEach((item) => {
              if (
                item.name.includes("[能量体系名称]") &&
                this.energySystemNameA
              ) {
                item.name = item.name.replace(
                  "[能量体系名称]",
                  this.energySystemNameA.replace("体系", "")
                );
              }

              let obj = {
                name: item.name,
                unit: item.unit,
              };
              //动态生成数据
              opEconomicBenefitVOList.forEach((el, index) => {
                if (item.filed === "proCostRatio" 
                    || item.filed === "ecoRatio" 
                    || item.filed === "highEco"
                    ||item.filed === "currentEco"
                ) {
                  let val3 = (
                    (el.opEconomicBenefitTotal[item.field] || el.opEconomicBenefitTotal[item.field] === 0) && 
                    (el.opEconomicBenefitTotal[item.filed] || el.opEconomicBenefitTotal[item.filed] === 0)) ? 
                    el.opEconomicBenefitTotal[item.field] - el.opEconomicBenefitTotal[item.filed] : '-'
                  let val1 = obj[`f${index}Val1`] = el.opEconomicBenefitTotal[item.filed];
                  if(item.filed === "proCostRatio" || item.filed === "ecoRatio"){
                    obj[`f${index}Val1`] = val1 ? val1 * 100 : undefined;
                  }else{
                    obj[`f${index}Val1`] = val1
                  }
                  obj[`f${index}Val2`] = el.opEconomicBenefitTotal[item.field];
                  obj[`f${index}Val3`] = val3;
                  obj[`f${index}Val4`] = val3 === '-' ? undefined : ((val3 || 0) / Math.abs(el.opEconomicBenefitTotal[item.filed] || 1) * 100);
                } 
                else {
                  let val3 = ((el[item.field] || el[item.field] === 0) && (el[item.filed] || el[item.filed] === 0)) ? el[item.field] - el[item.filed] : '-'
                  obj[`f${index}Val1`] = el[item.filed];
                  obj[`f${index}Val2`] = el[item.field];
                  obj[`f${index}Val3`] = val3;
                  obj[`f${index}Val4`] = val3 === '-' ? undefined : ((val3 || 0) / Math.abs(el[item.filed] || 1) * 100);
                }
              });
              if(item.filed === 'currentDietPrice' || item.filed === 'lowProCostDietPirce'){
                obj.f0 = obj.f0 ? obj.f0 * 1000 : null
              }

              list.push(obj);
            });
            this.list = list; //赋值


            //图表数据
            let sourceOne = [["product", "当前配方", "推荐配方"]];
            let sourceTwo = [["product", "当前配方", "推荐配方"]];
            let sourceThree = [["product", "当前配方", "推荐配方"]];
            let sourceFour = [["product", "当前配方", "推荐配方"]];
            
            opEconomicBenefitVOList.forEach((el, index) => {
              let { opEconomicBenefitTotal, ...newObj } = el || {};
              let arr = { ...opEconomicBenefitTotal, ...newObj };
              let { pigFeedingProgramWeightList } = this.procedureDetail || [];
              let { startWeight, endWeight } =
                pigFeedingProgramWeightList[index];
              let str = `${startWeight}-${endWeight}kg`;

              sourceOne.push([str, arr.currentE, arr.lowProCostE]);
              sourceTwo.push([str,arr.currentDietPrice,arr.lowProCostDietPirce]);
              sourceThree.push([str, arr.currentFg, arr.lowProCostFg]);
              sourceFour.push([str, arr.currentProCost, arr.lowProCost]);
            });

            this.chartsOne[0].dataset.source = sourceOne;
            this.chartsOne[1].dataset.source = sourceTwo;
            this.chartsOne[2].dataset.source = sourceThree;
            this.chartsOne[3].dataset.source = sourceFour;

            this.chartResources = [...this.chartsOne];

          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    init() {
      if (this.estimateId && this.isAdd) {
        this.getDetails(this.estimateId);
      } else if (!this.isAdd && this.resId) {
        this.getDetails(this.resId);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.chartStyle {
  width: 48%;
  height: 400px;
  box-shadow: 2px 3px 6px 0 rgb(199, 199, 199);
  margin-top: 24px;
  margin-right: 2%;
}
.cardBox {
  display: flex;
  flex-wrap: wrap;
}
</style>